import React, { useEffect, useRef, useState } from 'react'
import {
    View,
    Text,
    Image,
    ImageBackground,
    ScrollView,
    useWindowDimensions,
    Dimensions,
    StatusBar,
    TouchableOpacity,
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import styles from './GamificationRankingStyles'
import theme from '../../../theme'
import { avatarPlaceholder, placeholderGeneral } from '../customUtils/Constants'
import { FlatList } from 'react-native-gesture-handler'
import { useNavigation } from '@react-navigation/native'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { RoundedTabs, RoundedTabsGamification } from '../customUtils/LinealTabs'
import { useGamification } from './context/gamification.context'
import { LinearGradient } from 'expo-linear-gradient'
import { TriviaTheme } from '../../../themeConstants'
const { width, height } = Dimensions.get('window')

export const GamificationRanking = () => {
    const navigation = useNavigation()
    const { ranking, history } = useGamification()

    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={theme.colors.colorPrimary} barStyle='light-content' /> */}

            <View style={styles.arrow}>
                <TouchableOpacity
                    style={{ width: 24, height: 24 }}
                    onPress={() => navigation.goBack()}
                >
                    <Ionicons name='arrow-back-outline' size={24} color={'white'} />
                </TouchableOpacity>
            </View>

            <GamificationTabs positions={ranking} history={history} />
        </View>
    )
}

const RankingItem = ({ item }) => {
    const { languageFile } = getLanguage()
    const [image, setImage] = useState(item.avatar ? item.avatar : avatarPlaceholder)

    return (
        <View>
            <View
                style={[
                    styles.triviaItem,
                    { pointerEvents: 'none', paddingTop: 12, paddingBottom: 2 },
                ]}
            >
                <Text
                    style={[
                        styles.triviaName,
                        {
                            marginEnd: 12,
                            color: TriviaTheme.rankingPositionTextColor,
                            fontSize: 16,
                        },
                    ]}
                >
                    {item.position + '°'}
                </Text>

                <Image
                    style={styles.triviaImage}
                    source={{ uri: image }}
                    onError={() => {
                        setImage(avatarPlaceholder)
                    }}
                />
                <View
                    style={{
                        flex: 1,
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Text
                        style={[
                            styles.triviaDescription,
                            {
                                marginEnd: 12,
                                color: TriviaTheme.rankingUserTextColor,
                            },
                        ]}
                    >
                        {item.name + ' ' + item.last_name}
                    </Text>
                </View>

                <View
                    style={{
                        flexDirection: 'row',
                        borderWidth: 1,
                        borderColor: TriviaTheme.rankingPointsBorderColor,
                        backgroundColor: 'white',
                        borderRadius: 12,
                        alignContent: 'center',
                        alignItems: 'center',
                        paddingHorizontal: 12,
                        paddingVertical: 7,
                        paddingTop: 5,
                    }}
                >
                    <Text style={styles.podium_user_points_text}>{item.points}</Text>
                    <Text style={styles.podium_user_points_Pts}> pts</Text>
                </View>
            </View>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const HistoryItem = ({
    points,
    activity,
    dateString,
}: {
    points: number
    activity: string
    dateString: string
}) => {
    function parseFecha(dateString: string): { date: string; time: string } {
        const dateObj = new Date(dateString)
        const day = String(dateObj.getDate()).padStart(2, '0')
        const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const year = dateObj.getFullYear()
        const hours = String(dateObj.getHours()).padStart(2, '0')
        const minutes = String(dateObj.getMinutes()).padStart(2, '0')

        return {
            date: `${day}/${month}/${year}`,
            time: `${hours}:${minutes}`,
        }
    }
    const { date, time } = parseFecha(dateString)

    return (
        <View style={{ flex: 1, marginHorizontal: 3 }}>
            <View style={styles.containerItem}>
                <View style={{ flex: 2 }}>
                    <Text style={styles.position}>+{points}pts</Text>
                </View>

                <View style={{ flex: 4 }}>
                    {/* <Text style={styles.username}>5 Reacciones en muro</Text> */}
                    <Text style={styles.username}>{activity}</Text>
                </View>
                <View style={{ flex: 2 }}>
                    <Text
                        style={[styles.points, { fontSize: 12, textAlign: 'right' }]}
                    >
                        {date}
                    </Text>
                    <Text style={[styles.hr, { fontSize: 12, textAlign: 'right' }]}>
                        {time}
                    </Text>
                </View>
            </View>
            <View style={styles.divider3}></View>
        </View>
    )
}

export const GamificationTabs = ({ positions = [], history = [] }) => {
    const [selectedIndex, setSelectedIndex] = React.useState(0)

    const { languageFile } = getLanguage()

    const tabs = [
        {
            name: 'Ranking',
            index: 0,
        },
        {
            name: languageFile.history,
            index: 1,
        },
    ]
    const emptyRanking = {
        full_name: 'Vacante',
        user_avatar: avatarPlaceholder,
        points: null,
    }

    let first_place = positions[0]
        ? {
              full_name: positions[0].name + ' ' + positions[0].last_name,
              user_avatar: positions[0].avatar,
              points: positions[0].points,
          }
        : emptyRanking
    let second_place = positions[1]
        ? {
              full_name: positions[1].name + ' ' + positions[1].last_name,
              user_avatar: positions[1].avatar,
              points: positions[1].points,
          }
        : emptyRanking
    let third_place = positions[2]
        ? {
              full_name: positions[2].name + ' ' + positions[2].last_name,
              user_avatar: positions[2].avatar,
              points: positions[2].points,
          }
        : emptyRanking

    return (
        <View style={{ flex: 1 }}>
            <RoundedTabs
                tabs={tabs}
                selectedIndex={selectedIndex}
                colorSelected={theme.colors.colorSecondary}
                colorLGStart='transparent'
                colorLGEnd='transparent'
                colorUnselected={theme.colors.colorPrimary}
                onSelectedTab={(index) => {
                    setSelectedIndex(index)
                }}
                containerStyle={{}}
                textColorOff='white'
                textColorOn='white'
            />

            {(() => {
                switch (selectedIndex) {
                    case 0:
                        return (
                            <View style={{ flex: 1 }}>
                                <GamifPodium
                                    first_place={first_place}
                                    second_place={second_place}
                                    third_place={third_place}
                                />
                                <FlatList
                                    style={{ backgroundColor: 'white' }}
                                    data={positions.slice(3)}
                                    keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                    horizontal={false}
                                    showsHorizontalScrollIndicator={false}
                                    showsVerticalScrollIndicator={false}
                                    renderItem={({ item }) => (
                                        <RankingItem item={item} />
                                    )}
                                />
                            </View>
                        )
                    case 1:
                        return (
                            <View
                                style={{
                                    flex: 1,
                                    backgroundColor: 'white',
                                    paddingTop: 20,
                                    paddingBottom: 5,
                                    marginTop: 0,
                                    zIndex: 0,
                                }}
                            >
                                <View
                                    style={{
                                        zIndex: 20,
                                        flexDirection: 'row',
                                        paddingBottom: 15,
                                        paddingTop: 5,
                                        marginTop: -10,
                                    }}
                                >
                                    <Text
                                        style={{
                                            flex: 2,
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                            color: theme.colors.colorSecondary,
                                            marginHorizontal: 10,
                                        }}
                                    >
                                        Puntos
                                    </Text>
                                    <Text
                                        style={{
                                            flex: 3,
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                            marginHorizontal: -7,
                                        }}
                                    >
                                        Actividad
                                    </Text>
                                    <Text
                                        style={{
                                            flex: 3,
                                            fontSize: 16,
                                            fontWeight: 'bold',
                                            color: theme.colors.colorPrimary,
                                            marginRight: 15,
                                            textAlign: 'right',
                                        }}
                                    >
                                        Fecha
                                    </Text>
                                </View>
                                <FlatList
                                    data={history}
                                    keyExtractor={(item, index) => index.toString()} // Usa el índice como clave
                                    horizontal={false}
                                    showsHorizontalScrollIndicator={false}
                                    showsVerticalScrollIndicator={false}
                                    renderItem={({ item }) => (
                                        <HistoryItem
                                            points={item.points}
                                            activity={item.description}
                                            dateString={item.date}
                                        />
                                    )}
                                />
                            </View>
                        )
                    default:
                        return <Text>{languageFile.there_was_a_mistake}</Text>
                }
            })()}
        </View>
    )
}

export const GamifPodium = ({ first_place, second_place, third_place }) => {
    function validateImage(image) {
        if (image == undefined || image == null || image == '') {
            return avatarPlaceholder
        }
        return image
    }
    const [first_place_image, setFirstPlaceImage] = useState(
        validateImage(first_place.user_avatar),
    )
    const [second_place_image, setSecondPlaceImage] = useState(
        validateImage(second_place.user_avatar),
    )
    const [third_place_image, setThirdPlaceImage] = useState(
        validateImage(third_place.user_avatar),
    )

    return (
        <View>
            <Image
                source={require('../../../assets/gamification/ranking_background.png')}
                style={{ width: width, height: 175, zIndex: 0, marginTop: 0 }}
                resizeMethod='resize'
            />
            <View
                style={{
                    flexDirection: 'row',
                    position: 'absolute',
                }}
            >
                <View
                    style={{
                        flex: 1,
                        top: '10%',
                        start: '10%',
                    }}
                >
                    {second_place && (
                        <View
                            style={{
                                position: 'absolute',
                                zIndex: 2,
                                alignSelf: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                                width: 100,
                            }}
                        >
                            <Text
                                style={{
                                    zIndex: 6,
                                    color: 'white',
                                    fontSize: 24,
                                    fontWeight: '800',
                                    width: 34,
                                    height: 34,
                                    borderRadius: 17,
                                    alignSelf: 'flex-end',
                                    backgroundColor:
                                        theme.colors.RankingSecondPlaceColor,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginTop: 3,
                                    marginRight: 3,
                                    overflow: 'hidden',
                                    lineHeight: 32,
                                }}
                            >
                                2
                            </Text>
                            <Image
                                source={{ uri: second_place_image }}
                                style={[
                                    {
                                        zIndex: 4,
                                        width: 60,
                                        height: 60,
                                        borderRadius: 30,
                                        borderWidth: 3,
                                        borderColor: 'white',
                                        marginTop: -20,
                                    },
                                ]}
                                resizeMethod='resize'
                                resizeMode='contain'
                                onError={() => {
                                    setSecondPlaceImage(avatarPlaceholder)
                                }}
                            />
                            {second_place.points && (
                                <View
                                    style={[
                                        {
                                            zIndex: 5,
                                            width: 90,
                                            height: 25,
                                            borderRadius: 10,
                                            backgroundColor: 'white',
                                            marginTop: -6,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        },
                                    ]}
                                >
                                    <Text
                                        style={{
                                            color: theme.colors.RankingPointsColor,
                                            fontSize: 15,
                                            fontWeight: '800',
                                            textAlign: 'center',
                                            lineHeight: 20,
                                        }}
                                    >
                                        {second_place.points}
                                        <Text
                                            style={{
                                                color: theme.colors
                                                    .RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '400',
                                                lineHeight: 20,
                                            }}
                                        >
                                            pts
                                        </Text>
                                    </Text>
                                </View>
                            )}
                            <Text
                                style={{
                                    fontWeight: '500',
                                    marginVertical: 5,
                                    fontSize: 13,
                                    color: 'white',
                                }}
                                ellipsizeMode='tail'
                                numberOfLines={1}
                            >
                                {second_place.full_name}
                            </Text>
                        </View>
                    )}
                </View>
                <View style={{ flex: 1, top: '3.5%' }}>
                    {first_place && (
                        <View
                            style={{
                                alignSelf: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                                width: 100,
                            }}
                        >
                            <Text
                                style={{
                                    zIndex: 6,
                                    color: 'white',
                                    fontSize: 26,
                                    fontWeight: '800',
                                    width: 40,
                                    height: 40,
                                    borderRadius: 20,
                                    overflow: 'hidden',
                                    lineHeight: 36,
                                    alignSelf: 'flex-end',
                                    backgroundColor:
                                        theme.colors.RankingFirstPlaceColor,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginTop: 3,
                                    marginRight: 3,
                                }}
                            >
                                1
                            </Text>
                            <Image
                                source={{ uri: first_place_image }}
                                style={[
                                    {
                                        zIndex: 4,
                                        width: 60,
                                        height: 60,
                                        borderRadius: 30,
                                        borderWidth: 3,
                                        borderColor: 'white',
                                        marginTop: -20,
                                    },
                                ]}
                                resizeMethod='resize'
                                resizeMode='contain'
                                onError={() => {
                                    setFirstPlaceImage(avatarPlaceholder)
                                }}
                            />
                            {first_place.points && (
                                <View
                                    style={[
                                        {
                                            zIndex: 5,
                                            width: 90,
                                            height: 25,
                                            borderRadius: 10,
                                            backgroundColor: 'white',
                                            marginTop: -6,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        },
                                    ]}
                                >
                                    <Text
                                        style={{
                                            color: theme.colors.RankingPointsColor,
                                            fontSize: 15,
                                            fontWeight: '800',
                                            textAlign: 'center',
                                            lineHeight: 20,
                                        }}
                                    >
                                        {first_place.points}
                                        <Text
                                            style={{
                                                color: theme.colors
                                                    .RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '400',
                                                lineHeight: 20,
                                            }}
                                        >
                                            pts
                                        </Text>
                                    </Text>
                                </View>
                            )}

                            <Text
                                style={{
                                    fontWeight: '500',
                                    marginVertical: 5,
                                    fontSize: 13,
                                    color: 'white',
                                }}
                                ellipsizeMode='tail'
                                numberOfLines={1}
                            >
                                {first_place.full_name}
                            </Text>
                        </View>
                    )}
                </View>
                <View style={{ flex: 1, top: '10%', end: '10%' }}>
                    {third_place && (
                        <View
                            style={{
                                alignSelf: 'center',
                                alignContent: 'center',
                                alignItems: 'center',
                                width: 100,
                            }}
                        >
                            <Text
                                style={{
                                    zIndex: 6,
                                    color: 'white',
                                    fontSize: 24,
                                    fontWeight: '800',
                                    width: 34,
                                    height: 34,
                                    borderRadius: 17,
                                    alignSelf: 'flex-end',
                                    backgroundColor:
                                        theme.colors.RankingThirdPlaceColor,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    marginTop: 3,
                                    marginRight: 3,
                                    overflow: 'hidden',
                                    lineHeight: 32,
                                }}
                            >
                                3
                            </Text>
                            <Image
                                source={{ uri: third_place_image }}
                                style={[
                                    {
                                        zIndex: 4,
                                        width: 60,
                                        height: 60,
                                        borderRadius: 30,
                                        borderWidth: 3,
                                        borderColor: 'white',
                                        marginTop: -20,
                                    },
                                ]}
                                resizeMethod='resize'
                                resizeMode='contain'
                                onError={() => {
                                    setThirdPlaceImage(avatarPlaceholder)
                                }}
                            />
                            {third_place.points && (
                                <View
                                    style={[
                                        {
                                            zIndex: 5,
                                            width: 90,
                                            height: 25,
                                            borderRadius: 10,
                                            backgroundColor: 'white',
                                            marginTop: -6,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        },
                                    ]}
                                >
                                    <Text
                                        style={{
                                            color: theme.colors.RankingPointsColor,
                                            fontSize: 15,
                                            fontWeight: '800',
                                            textAlign: 'center',
                                            lineHeight: 20,
                                        }}
                                    >
                                        {third_place.points}
                                        <Text
                                            style={{
                                                color: theme.colors
                                                    .RankingPointsColor,
                                                fontSize: 15,
                                                fontWeight: '400',
                                                lineHeight: 20,
                                            }}
                                        >
                                            pts
                                        </Text>
                                    </Text>
                                </View>
                            )}
                            <Text
                                style={{
                                    fontWeight: '500',
                                    marginVertical: 5,
                                    fontSize: 13,
                                    color: 'white',
                                }}
                                ellipsizeMode='tail'
                                numberOfLines={1}
                            >
                                {third_place.full_name}
                            </Text>
                        </View>
                    )}
                </View>
            </View>
        </View>
    )
}
